{
  "items": [
    {
      "fileName": "GENERIC-HumanConnection-01.mp4",
      "description": "The video shows an extreme macro close up of one person's closed eye and eyelid, with a fair, tan skin tone showing fine wrinkles and skin texture, and dark eyelashes visible along the eyelid edge. The person's eye is fully closed, giving a calm, peaceful, still visible expression. The setting is an indoor environment with a plain, blurred background, softly out of focus, giving no additional visual context beyond the eye and skin. The lighting is warm and golden, coming from one side of the face, creating a gradient of warm highlights and darker shadow tones across the eyelid. The color palette is warm and golden, dominated by tan, amber, and brown tones, with darker shadow accents near the outer eye. The composition is an extreme close up, closeup, macro framing, with the eye and eyelid filling the entire frame. The visual style is photographic, realistic, and resembles a beauty or documentary style stock video with a shallow depth of field and detailed macro focus on skin texture and eyelashes.",
      "keyElements": ["background", "lighting", "shadow", "highlight"],
      "attributes": [
        "calm",
        "peaceful",
        "still",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "macro",
        "shallow depth of field",
        "warm lighting",
        "golden light",
        "warm tone",
        "documentary",
        "beauty",
        "eye",
        "eyelid",
        "eyelashes",
        "wrinkles",
        "skin texture",
        "tan",
        "amber",
        "brown",
        "shadow",
        "highlight"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-02.mp4",
      "description": "The video shows five people, a group of adults, gathered indoors in a group embrace, hugging one another in a close circle, giving a warm, joyful, affectionate visible expression, with several arms wrapped around shoulders and one arm stretched outward. The people are wearing a variety of tops, including a gray, light gray sweater, a light blue, denim colored sweatshirt, a pink, coral colored sweater, and other casual clothing, along with a denim, blue skirt. The setting is an indoor entryway or hallway environment, showing a white door frame and an open white door leading outside to a view of green trees and foliage, a wall with floral patterned curtains, a coat rack holding a navy blue jacket, a light pink jacket, and a teal, green colored handbag, along with a beige sofa and a framed picture on the wall. The lighting is bright and natural, consistent with daylight coming through the open door, evenly illuminating the group. The color palette is warm and neutral, dominated by white, gray, denim blue, and pink tones, with green accents from the trees outside and the handbag. The composition is a wide shot, full body framing, with the group positioned in the center of the frame, viewed mostly from behind. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a moderate depth of field, keeping the outdoor greenery visible through the open door.",
      "keyElements": [
        "door",
        "door frame",
        "trees",
        "foliage",
        "curtains",
        "coat rack",
        "jackets",
        "handbag",
        "sofa",
        "framed picture",
        "lighting"
      ],
      "attributes": [
        "warm",
        "joyful",
        "affectionate",
        "candid",
        "wide shot",
        "full body",
        "moderate depth of field",
        "bright lighting",
        "natural light",
        "warm tone",
        "family",
        "lifestyle",
        "group hug",
        "embrace",
        "gray",
        "denim blue",
        "pink",
        "coral",
        "jacket",
        "handbag",
        "coat rack",
        "door",
        "trees",
        "sofa",
        "reunion"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-03.mp4",
      "description": "The video shows a group of five women, young adult females with varying skin tones from fair to dark brown, gathered closely together outdoors, taking a selfie photograph. The women are smiling and laughing broadly with open mouths, showing white teeth, giving joyful, energetic, happy visible expressions. The women are wearing winter clothing, including a beige, tan colored knit hat, a black beanie, orange and brown jackets, and a light purple, lavender colored sweater, with one woman wearing sunglasses pushed up on her head. The setting is an outdoor environment, showing a bright, hazy sky with strong backlight sunlight creating a prominent lens flare and sun rays across the frame, and blurred green trees visible in the lower portion of the background. The lighting is very bright and strong, consistent with direct backlight sunlight, creating a hazy, glowing atmosphere and silhouetting some facial features. The color palette is bright and warm, dominated by tan, orange, brown, and lavender tones, with a bright white glow from the sun. The composition is a close up, closeup, group framing, with all five faces positioned across the frame at slightly varied heights, shot from a low angle as if from a handheld camera or phone. The visual style is photographic, realistic, and resembles a lifestyle or social media style stock video with strong lens flare and a moderate depth of field.",
      "keyElements": [
        "sky",
        "trees",
        "lens flare",
        "sun rays",
        "hat",
        "beanie",
        "jackets",
        "sunglasses",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "energetic",
        "happy",
        "candid",
        "close up",
        "closeup",
        "group",
        "selfie",
        "low angle",
        "lens flare",
        "backlight",
        "hazy",
        "bright lighting",
        "natural light",
        "warm tone",
        "social media",
        "lifestyle",
        "friends",
        "women",
        "tan",
        "orange",
        "brown",
        "lavender",
        "beanie",
        "hat",
        "sunglasses",
        "trees",
        "sky"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-04.mp4",
      "description": "The video shows two people, one man and one woman, a bride and groom, holding hands closely together outdoors. The woman is wearing a dress, a white, ivory colored lace wedding dress, along with a sheer white veil flowing in the wind, and a wedding ring visible on her finger. The man is wearing a suit, a blue, dark blue colored suit jacket, with his hand clasped around the woman's hand, also wearing a wedding ring. The setting is an outdoor environment, blurred heavily out of focus behind the couple, showing green trees and foliage, and a light colored car in the distance. The lighting is bright and soft, consistent with natural daylight, evenly illuminating the couple's hands without harsh shadows. The color palette is soft and neutral, dominated by white, ivory, blue, and green tones. The composition is an extreme close up, closeup, tight framing, focused entirely on the couple's clasped hands, with the veil visible flowing between their arms. The visual style is photographic, realistic, and resembles a wedding or romantic style stock video with a shallow depth of field, keeping the outdoor background softly blurred while the hands remain in sharp focus.",
      "keyElements": [
        "trees",
        "foliage",
        "car",
        "veil",
        "wedding ring",
        "suit color",
        "dress color",
        "lighting"
      ],
      "attributes": [
        "romantic",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "soft tone",
        "wedding",
        "romance",
        "couple",
        "bride",
        "groom",
        "hands",
        "holding hands",
        "wedding ring",
        "veil",
        "white",
        "ivory",
        "blue",
        "suit",
        "dress",
        "lace",
        "trees",
        "outdoor"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-05.mp4",
      "description": "The video shows an extreme macro close up of one man's eye and upper face, an elderly adult with a tan skin tone showing deep wrinkles, fine lines, and visible skin texture around the eye and nose. The man has dark brown eyes with a light colored reflection visible in the eye, and gray and dark eyebrows and eyelashes, looking upward and off to the side with a thoughtful, contemplative, still visible expression. The setting is an indoor environment with a plain, dark, blurred background, softly out of focus, giving no additional visual context beyond the man's face. The lighting is dim and directional, coming from one side of the face, creating strong shadows and highlights that emphasize the depth and texture of the skin and wrinkles. The color palette is dark and warm, dominated by brown, tan, and dark gray tones, with a small bright highlight reflected in the eye. The composition is an extreme close up, closeup, macro framing, with the eye and upper face filling the entire frame, angled slightly upward. The visual style is photographic, realistic, and resembles a documentary or emotional portrait style stock video with a shallow depth of field and dramatic, moody lighting.",
      "keyElements": ["background", "lighting", "shadow", "highlight"],
      "attributes": [
        "thoughtful",
        "contemplative",
        "still",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "macro",
        "shallow depth of field",
        "dim lighting",
        "dramatic lighting",
        "moody",
        "dark tone",
        "warm tone",
        "documentary",
        "elderly",
        "senior",
        "man",
        "eye",
        "eyebrow",
        "eyelashes",
        "wrinkles",
        "skin texture",
        "brown",
        "tan",
        "gray",
        "reflection"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-06.mp4",
      "description": "The video shows two people, one baby and one adult, with the baby's small hand, a fair skin toned infant hand, wrapped around and holding one adult finger tightly. The adult hand has a fair skin tone and light pink, lavender colored nail polish on the fingernails. The setting is an indoor environment, showing a white, soft fabric blanket or sheet draped and bunched around the hands, filling the background with soft folds and creases. The lighting is soft, bright, and diffused, consistent with gentle natural light, evenly illuminating the hands without harsh shadows. The color palette is soft and neutral, dominated by white and light skin tones, with a small lavender accent from the nail polish. The composition is an extreme close up, closeup, tight framing, focused entirely on the baby's hand and the adult's hand, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field and soft, gentle lighting.",
      "keyElements": ["blanket", "fabric", "nail polish", "lighting"],
      "attributes": [
        "gentle",
        "tender",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "soft lighting",
        "natural light",
        "neutral tone",
        "family",
        "lifestyle",
        "baby",
        "infant",
        "hand",
        "finger",
        "holding hands",
        "blanket",
        "white",
        "lavender",
        "nail polish",
        "newborn"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-07.mp4",
      "description": "The video shows two people, one man and one woman, a couple, embracing closely together outdoors. The woman is an adult female with a fair skin tone and long, reddish brown hair, wearing a top, a blue, denim colored jacket or shirt, along with a gray, patterned scarf, and carrying a brown leather bag over her shoulder, smiling broadly with her eyes closed, giving a warm, joyful, affectionate visible expression. The man is an adult male with a tan skin tone, curly gray and dark hair, and a gray beard, wearing eyeglasses, dark rimmed eyeglasses, and a jacket, a tan, beige colored jacket, along with a navy blue scarf, smiling broadly with an open mouth, showing white teeth, giving a warm, joyful, affectionate visible expression, with his hand holding the woman's hand. The setting is an outdoor urban street environment, blurred softly out of focus behind the couple, showing light colored buildings, storefronts, and architectural columns. The lighting is soft and natural, consistent with daytime outdoor lighting, evenly illuminating the couple. The color palette is warm and neutral, dominated by tan, blue, brown, and gray tones. The composition is a medium close up, closeup, upper body framing, with the couple positioned toward the center of the frame facing each other. The visual style is photographic, realistic, and resembles a lifestyle or romantic style stock video with a shallow depth of field, keeping the street background softly blurred.",
      "keyElements": [
        "buildings",
        "storefronts",
        "columns",
        "street",
        "scarf",
        "leather bag",
        "jacket color",
        "lighting"
      ],
      "attributes": [
        "warm",
        "joyful",
        "affectionate",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "romantic",
        "couple",
        "lifestyle",
        "man",
        "woman",
        "gray hair",
        "beard",
        "eyeglasses",
        "glasses",
        "scarf",
        "leather bag",
        "blue",
        "tan",
        "beige",
        "buildings",
        "street",
        "embrace"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-08.mp4",
      "description": "The video shows two people's hands clasped together, one hand with a fair skin tone wearing a tan, beige colored sleeve with a light green cuff and a wristwatch, and the other hand with a dark brown skin tone wearing a white sleeve. The hands are clasped in a gentle, comforting hold, with fingers interlaced. The setting is an indoor environment, blurred softly out of focus behind the hands, showing indistinct light colored furniture, a dark object, and a green accent in the background. The lighting is soft, warm, and natural, evenly illuminating the hands without harsh shadows. The color palette is warm and neutral, dominated by tan, beige, white, and brown skin tones, with a green accent in the background. The composition is an extreme close up, closeup, tight framing, focused entirely on the clasped hands, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or caregiving style stock video with a shallow depth of field, keeping the background softly blurred while the hands remain in sharp focus.",
      "keyElements": [
        "furniture",
        "background",
        "wristwatch",
        "sleeve color",
        "lighting"
      ],
      "attributes": [
        "gentle",
        "comforting",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "caregiving",
        "lifestyle",
        "hands",
        "holding hands",
        "wristwatch",
        "tan",
        "beige",
        "white",
        "green",
        "support",
        "comfort"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-09.mp4",
      "description": "The video shows an extreme macro close up of one person's closed eye and eyelid, with a dark brown skin tone and dark eyelashes visible along the eyelid edge, catching a bright highlight. The person's eye is fully closed, giving a calm, peaceful, still visible expression. The setting is an indoor environment with a plain, dark, blurred background, softly out of focus, giving no additional visual context beyond the eye and skin. The lighting is dim and directional, coming from one side of the face, creating a strong highlight along the upper eyelid while the surrounding skin remains in shadow. The color palette is dark and warm, dominated by deep brown and black tones, with a bright warm highlight along the eyelid. The composition is an extreme close up, closeup, macro framing, with the eye and eyelid filling the entire frame. The visual style is photographic, realistic, and resembles a beauty or documentary style stock video with a shallow depth of field and dramatic, moody lighting.",
      "keyElements": ["background", "lighting", "shadow", "highlight"],
      "attributes": [
        "calm",
        "peaceful",
        "still",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "macro",
        "shallow depth of field",
        "dim lighting",
        "dramatic lighting",
        "moody",
        "dark tone",
        "warm tone",
        "documentary",
        "beauty",
        "eye",
        "eyelid",
        "eyelashes",
        "skin texture",
        "brown",
        "black",
        "highlight",
        "shadow"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-10.mp4",
      "description": "The video shows two people, one man and one woman, a couple, embracing closely together outdoors at a stadium or sports venue. The woman is a young adult female with a fair skin tone and long, reddish brown curly hair, wearing a top, a maroon, dark red colored t-shirt, laughing broadly with her eyes closed, giving a joyful, excited, happy visible expression, with one arm raised near her head. The man is a young adult male with a tan skin tone and short, dark curly hair, along with light facial hair, wearing a top, a white t-shirt, laughing broadly with an open mouth, showing white teeth, giving a joyful, excited, happy visible expression, with one arm wrapped around the woman. The setting is an outdoor stadium environment, blurred softly out of focus behind the couple, showing rows of stadium seating or bleachers, and other spectators, including a man wearing a beige cap and a woman wearing a red cap, clapping and cheering. The lighting is bright and natural, consistent with daytime outdoor lighting, evenly illuminating the couple. The color palette is warm and bright, dominated by maroon, white, tan, and beige tones. The composition is a medium close up, closeup, upper body framing, with the couple positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or sports event style stock video with a shallow depth of field, keeping the stadium background softly blurred.",
      "keyElements": [
        "stadium seating",
        "bleachers",
        "spectators",
        "cap",
        "shirt color",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "excited",
        "happy",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "warm tone",
        "sports",
        "stadium",
        "lifestyle",
        "couple",
        "man",
        "woman",
        "curly hair",
        "maroon",
        "white",
        "cap",
        "bleachers",
        "cheering",
        "celebration"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-11.mp4",
      "description": "The video shows two people's hands clasped together, resting on the leg of one person seated, with both hands showing a fair, tan skin tone and visible wrinkles suggesting an elderly age. One hand is folded and held by the other in a comforting, supportive grip. The people are wearing pants, tan, beige colored trousers, and a top, a blue, denim colored shirt. The setting is an indoor environment, showing additional seated people nearby, with a light gray chair visible in the background, suggesting a group or waiting room setting. The lighting is soft, bright, and neutral, consistent with even indoor lighting, evenly illuminating the hands without harsh shadows. The color palette is warm and neutral, dominated by tan, beige, blue, and gray tones. The composition is an extreme close up, closeup, tight framing, focused entirely on the clasped hands, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or support group style stock video with a shallow depth of field, keeping the background softly blurred while the hands remain in sharp focus.",
      "keyElements": [
        "chair",
        "background",
        "shirt color",
        "pants color",
        "lighting"
      ],
      "attributes": [
        "comforting",
        "supportive",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "neutral tone",
        "elderly",
        "senior",
        "support group",
        "lifestyle",
        "hands",
        "holding hands",
        "wrinkles",
        "tan",
        "beige",
        "blue",
        "denim",
        "chair",
        "comfort"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-12.mp4",
      "description": "The video shows two people's hands, one hand with a fair skin tone reaching out to receive, and another hand with a fair skin tone holding and passing a set of keys, a silver, metal key attached to a pink and black colored keychain. The people are wearing tops, one wearing a tan, beige colored knit sweater, and the other wearing a dark brown colored sleeve and a white shirt underneath. The setting is an indoor environment, blurred softly out of focus behind the hands, showing stacked cardboard boxes in yellow and tan tones, and a tan colored sofa or couch. The lighting is warm and bright, consistent with natural indoor lighting, evenly illuminating the hands and keys. The color palette is warm and neutral, dominated by tan, beige, brown, and yellow tones, with a pink accent from the keychain. The composition is an extreme close up, closeup, tight framing, focused entirely on the hands and keys, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or real estate style stock video with a shallow depth of field, keeping the moving boxes background softly blurred.",
      "keyElements": [
        "cardboard boxes",
        "sofa",
        "couch",
        "keys",
        "keychain",
        "sweater color",
        "lighting"
      ],
      "attributes": [
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "warm lighting",
        "natural light",
        "warm tone",
        "real estate",
        "moving",
        "lifestyle",
        "hands",
        "keys",
        "keychain",
        "tan",
        "beige",
        "brown",
        "yellow",
        "pink",
        "cardboard box",
        "sofa",
        "new home"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-13.mp4",
      "description": "The video shows two people, one woman and one man, an elderly adult, sitting closely together indoors looking at a tablet or phone screen. The woman is a young adult female with a fair skin tone and long, dark brown hair, wearing a top, a gray, olive green knit sweater, waving one hand toward the screen, smiling broadly with an open mouth, showing white teeth, giving a joyful, warm, happy visible expression. The man is an elderly adult male with a fair skin tone and short, white, gray hair, along with light facial stubble, wearing a top, a navy blue and green plaid, checkered patterned shirt, smiling with his mouth open, giving a warm, joyful, engaged visible expression, looking toward the woman and the screen. The setting is an indoor home environment, blurred softly out of focus behind the pair, showing a plain dark wall and a light colored armrest or cushion. The lighting is soft and dim, consistent with warm indoor ambient lighting, creating a cozy atmosphere. The color palette is warm and muted, dominated by gray, green, navy blue, and tan tones. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame, facing a screen held in the foreground. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field and warm, cozy lighting.",
      "keyElements": [
        "wall",
        "armrest",
        "cushion",
        "tablet",
        "phone",
        "sweater color",
        "shirt pattern",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "happy",
        "engaged",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "dim lighting",
        "cozy",
        "warm tone",
        "family",
        "lifestyle",
        "woman",
        "man",
        "elderly",
        "senior",
        "gray hair",
        "white hair",
        "plaid",
        "checkered",
        "green",
        "navy blue",
        "tablet",
        "phone",
        "video call",
        "waving"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-14.mp4",
      "description": "The video shows two people, one man and one woman, embracing closely together outdoors. The man is an adult male with a dark brown skin tone and short, dark curly hair, wearing a top, a gray, olive green colored jacket or vest over a blue shirt, seen mostly from behind with his arms wrapped around the woman. The woman is an adult female with a tan skin tone and short, gray, silver hair, wearing a top, a blue, light blue colored scrub top, along with a rust, orange colored jacket draped over her shoulders, and small stud earrings, laughing broadly with an open mouth, showing white teeth, giving a joyful, warm, happy visible expression. The setting is an outdoor park environment, blurred softly out of focus behind the couple, showing tall green trees, dappled sunlight, and another person wearing a cap visible in the background. The lighting is bright and natural, consistent with dappled sunlight filtering through the trees, creating soft highlights on the couple. The color palette is warm and bright, dominated by green, blue, orange, and gray tones. The composition is a medium close up, closeup, upper body framing, with the couple positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or emotional reunion style stock video with a shallow depth of field, keeping the park background softly blurred.",
      "keyElements": [
        "trees",
        "sunlight",
        "park",
        "jacket",
        "scrub top",
        "earrings",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "happy",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "dappled light",
        "warm tone",
        "reunion",
        "lifestyle",
        "man",
        "woman",
        "gray hair",
        "silver hair",
        "curly hair",
        "scrub top",
        "blue",
        "orange",
        "green",
        "trees",
        "park",
        "hug",
        "embrace"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-15.mp4",
      "description": "The video shows two people, one adult and one elderly man, indoors near a window. One hand, with a fair skin tone wearing a white sleeve, rests gently on the shoulder of the elderly man, giving a comforting, supportive gesture. The elderly man has a fair skin tone, short gray and white hair, and light facial stubble, wearing a top, a tan, beige colored sweater, seated in a wheelchair, with a black wheelchair armrest visible in the lower portion of the frame, looking off to the side with a calm, thoughtful visible expression, his mouth slightly open. The setting is an indoor environment near a window, showing a light colored wall, window blinds, and a blurred view of green foliage outside through the window. The lighting is soft and bright, consistent with natural daylight coming through the window, evenly illuminating the man and the comforting hand. The color palette is warm and neutral, dominated by tan, beige, white, and gray tones, with green accents from the foliage outside. The composition is an extreme close up, closeup, tight framing, focused on the shoulder, hand, and side of the man's face, positioned centrally in the frame. The visual style is photographic, realistic, and resembles a lifestyle or caregiving style stock video with a shallow depth of field, keeping the window and foliage background softly blurred.",
      "keyElements": [
        "window",
        "blinds",
        "foliage",
        "wheelchair",
        "sweater color",
        "lighting"
      ],
      "attributes": [
        "comforting",
        "supportive",
        "calm",
        "thoughtful",
        "candid",
        "close up",
        "closeup",
        "extreme close up",
        "shallow depth of field",
        "blurred background",
        "soft lighting",
        "natural light",
        "warm tone",
        "caregiving",
        "elderly",
        "senior",
        "lifestyle",
        "man",
        "wheelchair",
        "gray hair",
        "white hair",
        "tan",
        "beige",
        "hand on shoulder",
        "window",
        "foliage",
        "care"
      ]
    },
    {
      "fileName": "GENERIC-HumanConnection-16.mp4",
      "description": "The video shows two people, one woman and one woman, two adult females, embracing closely together outdoors. One woman has a fair skin tone and long, dark brown hair, wearing a top, a tan, beige colored jacket, hugging the other woman with her back facing the camera and one arm raised outward. The other woman has a fair skin tone and long, dark brown hair, wearing a top, a navy blue colored shirt, smiling broadly with an open mouth, showing white teeth, giving a joyful, warm, happy visible expression, with her eyes nearly closed from smiling. The setting is an outdoor park environment, blurred softly out of focus behind the pair, showing tall green trees and bright, hazy backlight sunlight filtering through the leaves, creating a strong glow and soft lens flare around the women's hair. The lighting is bright and warm, consistent with strong backlight sunlight, creating a hazy, glowing atmosphere. The color palette is warm and bright, dominated by tan, beige, navy blue, and green tones, with a bright white glow from the sun. The composition is a medium close up, closeup, upper body framing, with both women positioned toward the center of the frame. The visual style is photographic, realistic, and resembles a lifestyle or emotional reunion style stock video with a shallow depth of field, backlight, and lens flare, keeping the park background softly blurred.",
      "keyElements": [
        "trees",
        "park",
        "backlight",
        "lens flare",
        "jacket color",
        "shirt color",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "happy",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "backlight",
        "lens flare",
        "hazy",
        "bright lighting",
        "natural light",
        "warm tone",
        "reunion",
        "lifestyle",
        "women",
        "friends",
        "tan",
        "beige",
        "navy blue",
        "trees",
        "park",
        "hug",
        "embrace"
      ]
    }
  ]
}
